<h1 class="mt-4">Care Plan</h1>

<div *ngIf="(taskService.tasks$ | async) as tasks; else loading">
  <div
    class="card mb-4"
    *ngIf="
      tasks.overdue?.length > 0 || tasks.due?.length > 0 || tasks.future?.length > 0;
      else emptyState
    "
  >
    <ng-container *ngFor="let section of SECTIONS">
      <ng-container *ngIf="tasks[section.dueRange] && tasks[section.dueRange].length > 0">
        <div class="card-header">{{ section.label }}</div>
        <ul class="list-group list-group-flush">
          <li
            *ngFor="let task of tasks[section.dueRange]"
            (click)="goToTask(task.id)"
            class="list-group-item"
          >
            <div [ngClass]="['task-icon', task.iconName]"></div>
            <div class="task-summary py-3">
              <h5 class="mb-0 mt-0">{{ task.phiVisibleTitle }}</h5>
              <div *ngIf="task.subtitle">{{ task.subtitle }}</div>
              <div [ngClass]="{ 'text-danger': section.dueRange === 'overdue' }">
                {{ task.scheduledAtString }}
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
    </ng-container>
  </div>
  <ng-template #emptyState>
    <div class="card mb-4">
      <div class="card-header">This week</div>
      <div class="card-body text-center">
        <img src="/assets/images/task-empty-state.png" class="empty-state" />
        <h2>You currently have no Action Items to complete.</h2>
        <p>
          Here you’ll see your Care Plan from your provider. You'll receive a reminder and
          instructions so you can take action and stay healthy.
        </p>
      </div>
    </div>
  </ng-template>
</div>
<ng-template #loading>
  <div class="text-center"><om-spinner></om-spinner></div>
</ng-template>
